import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { ProductRatingResponse, ProductRatingResponseData } from 'src/app/services/rating/rating.type';

@Component({
  selector: 'app-show-rating',
  templateUrl: './show-rating.component.html',
  styleUrls: ['./show-rating.component.scss']
})
export class ShowRatingComponent implements OnInit {

  @Input() avgRating?: number;
  @Input() ratingCount?: number;
  @Input() checkIfUserReviewed?: boolean;
  @Input() productId: string;
  @Input() orderId?: number;
  @Output() clickedToRate = new EventEmitter<boolean>();
  rating: number = 0;
  ratingAndReviews: ProductRatingResponseData[];
  activeUserReviewCount = 0;
  rateDesc = 'Rate product :';

  constructor(private ratingService: RatingService, private apiService: ApiService) { }

  ngOnInit(): void {
    if(this.checkIfUserReviewed) {
      this.ratingService.getRating(Number(this.productId), this.orderId).subscribe((res:  ProductRatingResponse) => {
        let avgRating = 0;
  
        this.ratingAndReviews = res.ResponseData;
          this.ratingAndReviews.map(r => {
  
            if(this.apiService.getUserdetails().ID === r.UserId) {
              this.activeUserReviewCount++;
              avgRating = r.Rating;
            } 
            if(this.activeUserReviewCount === 0) {
              avgRating += r.Rating;
            }
          });
  
          if( this.activeUserReviewCount === 0) {
            this.rating = avgRating/this.ratingAndReviews.length;
          } else {
            this.rating = avgRating;
            this.rateDesc = 'You have rated :'
          }
      });
    } else {
      this.rating = this.avgRating;
    }
  }

  public rateTheProduct() {
    if(!this.checkIfUserReviewed || this.activeUserReviewCount > 0){
      return
    }
    this.clickedToRate.emit(true);
  }

}
